// Module
var code = "<input data-bind=\"checked: $parent.GetValue(Name), attr: { 'data-on-text': _labels.ON, 'data-off-text': _labels.OFF }\" type=\"checkbox\" class=\"make-switch\">";
// Exports
export default code;